import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.6rem;

  padding: 1.2rem 0;

  border-top: 0.2rem solid ${pickColor('borderColorDark')};
  background-color: ${pickColor('white')};
`;

const TotalGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
  min-width: 12rem;
`;

const Label = styled.span`
  ${getFontScale('xs')};
  color: ${pickColor('grayDark')};
  text-transform: uppercase;
`;

const QuantityValue = styled.span`
  ${getFontScale('s')};
  font-weight: bold;
  color: ${pickColor('black')};
`;

const PriceValue = styled.span`
  ${getFontScale('s')};
  font-weight: bold;
  color: ${pickColor('black')};
`;

// Kept for backward compat with existing tests / imports
const TotalLabel = Label;

export { Footer, Label, PriceValue, QuantityValue, TotalGroup, TotalLabel };
